<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-22 14:09:53
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 13:54:19
-->
<template>
  <div class="innovative innovative-accuffroct" :class="{textj: language != 'en'}" ref="accuffroct">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/m/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.accuffroct.title')"></div>
    </div>
    <div class="p-t-50 p-b-10">
      <div class="p-l-30 p-r-30">
        <div class="innovative-item-title p-l-25" v-html="$t('product.accuffroct.list[0].title')"></div>
      </div>
      <div class="p-t-28 p-l-24 p-r-20">
        <img class="wid100" :src="$t('product.accuffroct.list[0].img')" alt="" srcset="">
      </div>
      <div class="p-l-30 p-r-30 textj">
        <p class="p-t-20 p-b-20" v-for="item, index in $t('product.accuffroct.list[0].des')" :key="index" v-html="item"></p>
      </div>
    </div>
    <div class="accuffroct-advantages">
      <div class="innovative-item-title" v-html="$t('product.accuffroct.list[1].title')"></div>
      <div class="accuffroct-advantages-box">
        <div class="p-b-60" v-for="item, index in $t('product.accuffroct.list[1].des')" :key="index">
          <div class="textc p-b-20">
            <img class="" :src="item.img" alt="" srcset="">
          </div>
          <div class="innovative-wrap-item-title textc fz-30 p-b-30" :class="index != 0 ? 'p-t-30' : ''" v-html="item.title"></div>
          <div class="flex_1">
            <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="innovative-container">
      <div class="p-t-20 article">
        <div class="innovative-item-title" v-html="$t('product.accuffroct.article.title')"></div>
        <div class="p-t-15">
          <p class="p-t-15" v-for="item, index in $t('product.accuffroct.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/m/products.less";
</style>

<style lang="less" scoped>
.m .innovative-accuffroct {
  .accuffroct-advantages {
    background: #F8FBFF;
    border-radius: 8px;
    padding: 50px 30px 0 30px;
    img {
      max-width: 100%;
    }
    .accuffroct-advantages-box {
      padding: 50px 6.5% 0 6.5%;
      line-height: 60px;
    }
  }
}
</style>
